<template>
  <div class="box">
    <div v-if="fileList.length>0" class="flex-box">
      <div class="file-item" v-for="(item, index) in newFileList" :key="index+'a'" v-show="item.type!==8">
        <img :src="item.fileImg" alt="">
        <span class="file-name">{{item.name}}</span>
        <div class="action">
          <el-button type="text" @click="openFile(item.path, item.suffix,index)">查看</el-button>
        </div>
      </div>
    </div>
    <Empty text="暂无材料" v-else />
    <ImageDialog ref="imageDialog"/>
    <VideoPlayer ref="videoPlayer"/>
    <viewer :images="imagesList" @inited="inited" class="viewer" ref="viewer">
      <img v-show="false" v-for="(item, index) in imagesList" :src="item" :key="index" />
    </viewer>
  </div>
</template>

<script>
import { getSuffix, myConfirm } from "@/utils/tools.js";
import VideoPlayer from "@/components/videoPlayer.vue";
import ImageDialog from "@/components/imageDialog.vue";
import Empty from './empty';
import { mapGetters } from "vuex";
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import Vue from 'vue'
Vue.use(Viewer)
export default {
  components: {
    VideoPlayer,
    ImageDialog,
    Empty
  },
  props: {
    fileList: {
      type: Array,
      require: true
    },
    disabled: {
      require: true
    },
    openType: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      imagesList: [],
      images: [],
      dialogImage: false,
    }
  },
  watch: {
    fileList: {
      immediate: true,
      deep: true,
      handler() {
        this.imagesList = [];
      }
    }
  },
  computed: {
    newFileList() {
      let temData;
      if (this.fileList.length === 0) {
        temData = [];
      } else {
        temData = JSON.parse(JSON.stringify(this.fileList));
      }
      // let temData = JSON.parse(JSON.stringify(this.fileList));
      temData.map(item => {
        let suffix;
        if (item.path) {
          suffix = getSuffix(item.path);
        } else {
          suffix = '?';
        }
        item.suffix = suffix;

        switch (true) {
          case suffix == "pdf" || suffix == "pdfx":
            item.fileImg = require("../image/file_icon/pdf.png");
            break;
          case suffix == "xls" || suffix == "xlsx":
            item.fileImg = require("../image/file_icon/excel.png");
            break;
          case suffix == "doc" || suffix == "docx":
            item.fileImg = require("../image/file_icon/word.png");
            break;
          case suffix == "mp4" ||
            suffix == "MP4" ||
            suffix == "avi" ||
            suffix == "rmvb" ||
            suffix == "mkv":
            item.fileImg = require("../image/file_icon/video.png");
            break;
          case suffix == "zip" ||
            suffix == "7z":
            item.fileImg = require("../image/file_icon/zip.png");
            break;
          case suffix == "jpg" ||
            suffix == "jpeg" ||
            suffix == "png" ||
            suffix == "gif":
            item.fileImg = require("../image/file_icon/image.png");
            item.fileType = "image";
            this.imagesList.push(item.path);
            break;
          case suffix == 'txt':
            item.fileImg = require("../image/file_icon/txt.png");
            break;
          default:
            item.fileImg = require("../image/file_icon/unknown.png");
            break;
        }
      });
      return temData;
    }
  },
  mounted() {

  },
  methods: {
    inited(viewer) {
      this.$viewer = viewer;
    },
    show() {
      this.$viewer.show();
    },
    onDel(id, index) {
      this.$api.deleteDoc(id).then(res => {
        if (res.data.code === '200') {
          this.$store.commit('case/deleteItemNotDoc', index);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 删除证件材料
    deleteItemNotDoc(id, index) {
      myConfirm({
        text: "是否确认该文件？",
        success:()=> {
          if (this.openType === 'add') {
            this.$store.commit('case/deleteItemNotDoc', index);
          } else {
            this.onDel(id, index);
          }
        }
      });
    },
    openFile(path, suffix,index) {
      if (
        suffix == "xls" ||
        suffix == "xlsx" ||
        suffix == "doc" ||
        suffix == "docx"
      ) {
        console.log("path:",path);
        console.log("suffix:",suffix);
        window.open("https://view.officeapps.live.com/op/view.aspx?src=" + path);
      } else if (
        suffix == "mp4" ||
        suffix == "MP4" ||
        suffix == "avi" ||
        suffix == "rmvb" ||
        suffix == "mkv"
      ) {
        // this.url = path;
        // this.dialogVideo = true;
        console.log(this.fileList);
        this.$refs.videoPlayer.open(path)
      } else if (
        suffix == "jpg" ||
        suffix == "jpeg" ||
        suffix == "png" ||
        suffix == "gif"
      ) {
        // this.dialogImage = true;
        // console.log(this.newFileList);
        // this.$refs.imageDialog.open(path)
        // this.show();
       
      this.imagesList.forEach((item,i)=>{
        if(item==path){
          this.$viewer.view(i)
        }
      })
        
        // this.$viewer.show();
       
      } else {
        window.open(path);
      }
    },
  }
}
</script>
<style lang="less" scoped>
@import '../style/mixin';
.box{
  .flex-box{
    .flex();
    flex-wrap: wrap;
  }
  .file-item{
    .flex(flex-start,column,center);
    margin-top: 20px;
    width: 150px;
    .file-name{
      width: 100px;
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
      margin-top: 10px;
      text-align: center;
    }
    img{
      width: 50px;
    }
  }
}
</style>